// extracted by mini-css-extract-plugin
export default {"page":"TermsPage_page__cK5Qd","content":"TermsPage_content__0O8BU"};